import React from 'react';
import './import-data.scss';

export function ImportData({ getBinary }) {

  const getBinaryFile = (fileXls) => {
    try {
      let file = fileXls.target.files[0];
      getBinary(file);

    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="import-data">
      <label>
        <input onChange={getBinaryFile} type="file" />
        <span className="btn btn-primary">
          Importar Lojas
        </span>
      </label>
    </div>
  );
}
